/**
 * Tetos de horas por ciclo (backend /hour-caps/*): o admin edita os limites
 * (colégio / itinerante / demais / geral) e consulta quem teve hora retida
 * no ciclo. O excedente fica guardado no próprio registro (saidaReal +
 * horasExcedentes); a CGP só enxerga o que é pagável.
 */
import api from './api';

export async function getHourCaps() {
  const response = await api.get('/hour-caps/config');
  return response.data;
}

/** Devolve { config, resumo: { ajustados, restaurados, militares } }. */
export async function updateHourCaps(partial) {
  const response = await api.patch('/hour-caps/config', partial);
  return response.data;
}

/** Militares com hora retida entre `inicio` e `fim` ('YYYY-MM-DD'). */
export async function getExcedentes(inicio, fim) {
  const response = await api.get('/hour-caps/excedentes', { params: { inicio, fim } });
  return response.data;
}

/** Refaz a alocação de todo mundo a partir de `desde` ('YYYY-MM-DD'). */
export async function realocarHourCaps(desde) {
  const response = await api.post('/hour-caps/realocar', null, { params: { desde } });
  return response.data;
}
